import { IIconProps } from './icon';

interface IIconPentagonProps extends IIconProps {
  width?: string;
  height?: string;
}

export const IconPentagon = ({
  style = {},
  cy,
  width = '14',
  height = '13',
}: IIconPentagonProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 13"
      fill="#FFFFFF"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      data-cy={`IconPentagon${cy}`}
    >
      <path d="M0.333374 4.83341L3.00004 12.8334H11L13.6667 4.83341L7.00004 0.166748L0.333374 4.83341Z" />
    </svg>
  );
};
